<template>
  <div
    class="agent-task-modal"
    id="agentTaskModal"
    data-agent-task-overlay
    :aria-hidden="!open"
    @click="handleOverlayClick"
  >
    <div class="agent-task-window" data-agent-task-window>
      <div class="agent-task-window-head">
        <div class="agent-task-window-main">
          <div class="agent-insight-eyebrow">Task Detail</div>
          <div class="agent-task-window-title">{{ title }}</div>
          <div class="agent-task-window-sub" v-if="detail">{{ detail.agentName }} · {{ scheduleLabel }} · {{ statusLabel }}</div>
          <div class="agent-task-window-sub" v-else>{{ sessionName }}</div>
        </div>
        <button class="agent-task-window-close" type="button" data-agent-task-modal-close @click="close">×</button>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="agent-task-window-body" style="display:flex;align-items:center;justify-content:center;min-height:200px;">
        <div style="text-align:center;">
          <div class="atm-spinner"></div>
          <div style="margin-top:10px;font-size:13px;color:#6F8398;font-weight:700;">加载中…</div>
        </div>
      </div>

      <!-- Detail -->
      <div v-else-if="detail" class="agent-task-window-body">
        <!-- 基本信息 -->
        <div class="agent-task-detail-metrics">
          <article class="agent-task-detail-metric">
            <strong>{{ scheduleLabel || '—' }}</strong>
            <span>执行频率</span>
          </article>
          <article class="agent-task-detail-metric">
            <strong>{{ lastRunTime }}</strong>
            <span>最近执行</span>
          </article>
          <article class="agent-task-detail-metric">
            <strong>{{ statusLabel || '—' }}</strong>
            <span>当前状态</span>
          </article>
        </div>

        <!-- 任务说明 -->
        <section class="agent-task-detail-card">
          <div class="agent-task-detail-head">
            <div>
              <div class="agent-task-detail-title">任务说明</div>
              <div class="agent-task-detail-sub">参考定时任务页的查看逻辑，当前以全屏弹窗方式展示任务详情。</div>
            </div>
          </div>
          <div class="agent-task-detail-copy">{{ detail.payloadText || '暂无任务说明' }}</div>
        </section>

        <!-- 关联交付物 -->
        <section class="agent-task-detail-card">
          <div class="agent-task-detail-head">
            <div>
              <div class="agent-task-detail-title">关联交付物</div>
              <div class="agent-task-detail-sub">当前任务执行完成后，会默认沉淀以下类型的结果文件。</div>
            </div>
          </div>
          <div v-if="detail.files && detail.files.length" class="agent-task-chip-list">
            <span v-for="f in detail.files" :key="f.id" class="agent-task-chip">{{ f.title }}</span>
          </div>
          <div v-else class="agent-task-detail-copy" style="color:#94A4B5;">暂无交付物</div>
        </section>

        <!-- 执行步骤 -->
        <section class="agent-task-detail-card">
          <div class="agent-task-detail-head">
            <div>
              <div class="agent-task-detail-title">执行步骤</div>
              <div class="agent-task-detail-sub">用于说明这个任务在后台会如何被拆解与执行。</div>
            </div>
          </div>
          <div v-if="detail && detail.steps && detail.steps.length" class="agent-task-steps-list">
            <div v-for="(step, si) in detail.steps" :key="si" class="agent-task-step-item">
              <span class="agent-task-step-num">{{ si + 1 }}</span>
              <span class="agent-task-step-text">{{ step.text }}</span>
            </div>
          </div>
          <div v-else class="agent-task-detail-copy" style="color:#94A4B5;">暂无执行步骤</div>
        </section>

      </div>

      <!-- Fallback -->
      <div v-else class="agent-task-window-body">
        <div class="agent-task-detail-copy">暂无任务详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'AgentTaskModal',
  computed: {
    ...mapState(['agentTaskPreview', 'currentSessionKey', 'sessionItems']),
    open() { return this.agentTaskPreview.open },
    loading() { return this.agentTaskPreview.detailLoading || false },
    detail() { return this.agentTaskPreview.detail || null },
    title() {
      if (this.detail) return this.detail.title
      // 从列表数据取标题
      const listTask = this.$store.getters.currentAgentTasks.find(t => t.id === this.agentTaskPreview.id)
      return listTask ? listTask.title : '任务详情'
    },
    sessionName() {
      const s = this.sessionItems.find(i => i.key === this.currentSessionKey)
      return s ? s.name : ''
    },
    scheduleLabel() {
      if (!this.detail) return '—'
      if (this.detail.scheduleDisplay) return this.detail.scheduleDisplay
      if (this.detail.scheduleCron) return this.detail.scheduleCron
      if (this.detail.scheduleEveryMinutes) return '每 ' + this.detail.scheduleEveryMinutes + ' 分钟'
      return this.detail.scheduleKind || '—'
    },
    lastRunTime() {
      if (!this.detail) return '—'
      const ts = this.detail.lastRunAtMs || this.detail.lastRunTs
      if (!ts) return '—'
      return this.fmtTime(ts)
    },
    statusLabel() {
      if (!this.detail) return '—'
      if (this.detail.lastRunStatus === 'error') return '异常'
      if (this.detail.lastRunStatus === 'success') return '已完成'
      if (this.detail.taskState === 'active') return '运行中'
      if (this.detail.taskState) return this.detail.taskState
      if (this.detail.enabled) return '待执行'
      return '—'
    }
  },
  methods: {
    ...mapActions(['closeAgentTaskPreview']),
    close() { this.closeAgentTaskPreview() },
    handleOverlayClick(e) {
      if (!e.target.closest('[data-agent-task-window]')) {
        this.close()
      }
    },
    fmtTime(ms) {
      if (!ms) return '—'
      return new Date(ms).toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
.atm-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(91,141,239,.15);
  border-top-color: #5B8DEF;
  border-radius: 50%;
  animation: atm-spin .7s linear infinite;
  margin: 0 auto;
}
@keyframes atm-spin {
  to { transform: rotate(360deg); }
}
.atm-runs-list {
  display: grid;
  gap: 6px;
}
.atm-run-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(248,250,253,.98);
  border: 1px solid rgba(228,233,242,.94);
  font-size: 12px;
  font-weight: 700;
}
.atm-run-time {
  color: #6F8398;
  min-width: 90px;
}
.atm-run-status {
  min-height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
}
.atm-run-status.is-ok {
  background: rgba(72,184,137,.10);
  color: #1a9e6e;
}
.atm-run-status.is-error {
  background: rgba(239,68,68,.08);
  color: #dc2626;
}
.atm-run-summary {
  flex: 1;
  color: #94A4B5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.atm-run-duration {
  color: #94A4B5;
  white-space: nowrap;
}
</style>
